export enum RoleNames {
  STUDENT = "student",
  PROFESSOR = "professor",
  ADMIN = "admin"
}
